import { atom } from "jotai";
import type {
    ProductFacetsResponse,
    ProductFacetsStatus,
} from "@models/productFacet";

// Brand + vendor facet values (#226). Cached in an atom rather than re-fetched per page
// because the values describe the whole catalogue and do not change as the shopper filters —
// so the sidebar and the mobile sheet can both render chips without a second round trip.
export const productFacetsAtom = atom<ProductFacetsResponse>({
    brands: [],
    vendors: [],
});

// The read's OUTCOME, which the payload above cannot express: a successful read of an empty
// catalogue and a failed read both leave the payload empty, and only one of them means the
// facets endpoint is there. The In-Stock toggle's visibility hangs off this — see
// ProductFacetsStatus for the full four-state contract.
export const productFacetsStatusAtom = atom<ProductFacetsStatus>("idle");

// The apiHooks folder's conventional isFetching… flag, kept unwired by ruling. Derived rather
// than stored a second time: two independently-set atoms describing one request can disagree,
// and a caller that raised one but forgot the other would go unnoticed.
//
// Note the narrower meaning that falls out of the status being stale-while-revalidate: this is
// true only while there is nothing to show — a first load, or a retry after a failure — and NOT
// during a background refresh that still has the previous facets on screen. That is the
// behaviour a spinner wants anyway; a refresh should not blank a populated panel.
export const isFetchingProductFacetsAtom = atom(
    (get) => get(productFacetsStatusAtom) === "loading",
);
